// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"0ea4fb0a","213":"0216ef70","239":"73d5c59a","422":"622ec0fb","732":"faa4309a","827":"b3940146"}[chunkId] + ".chunk.js";
};